(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["mega-menu-list"] && !Shopify.designMode) return;
  try {
    (() => {
    // Desktop discoverability: reveal a column's list on hover, not only on a click of
    // the caret, so a first-time visitor with a mouse sees these headers are expandable
    // without having to find and click the small caret first. This sets the SAME native
    // `open` attribute a click on the <summary> would set — a pure-CSS attempt to fake
    // the open look via :hover was tried first and rejected: this theme's accordion
    // relies on the browser's native handling of <details>/::details-content tied to the
    // real `open` attribute, and overriding just the computed opacity/block-size on a
    // class selector left the box with correct-looking computed styles but nothing
    // actually painted, so the "expanded" list stayed invisible. Toggling the attribute
    // itself avoids that entirely, and reuses the exact code path a click already uses.
    // Delegated on document with the bubbling mouseover/mouseout events (mouseenter and
    // mouseleave don't bubble) so it keeps working if the menu panel is ever re-rendered.
    const hoverCapable = window.matchMedia('(hover: hover) and (pointer: fine)');

    function detailsFor(column) {
      return column.querySelector('accordion-custom details');
    }

    document.addEventListener('mouseover', (event) => {
      if (!hoverCapable.matches) return;
      const column = event.target.closest('.mega-menu__column-inner');
      if (!column || column.contains(event.relatedTarget)) return;
      const details = detailsFor(column);
      if (details) details.setAttribute('open', '');
    });

    document.addEventListener('mouseout', (event) => {
      if (!hoverCapable.matches) return;
      const column = event.target.closest('.mega-menu__column-inner');
      if (!column || column.contains(event.relatedTarget)) return;
      const details = detailsFor(column);
      if (details) details.removeAttribute('open');
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
